import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, extends as _extends, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps, FormControlLabel, Checkbox } from '@mui/material';
import { TreeItem, TreeView } from '@mui/x-tree-view';
import Field from '../Field.js';
import connectForm$1 from '../../../cinnamon-core/es/components/forms/connectForm.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { prettifyField, omitProps, fieldErrors } from '../../../cinnamon-core/es/components/forms/utils.js';
import { requiredField } from '../../../cinnamon-core/es/components/forms/validators/requiredField.js';

var componentRoot = createComponentSlot({
  name: "CinFormCheckboxTree",
  slot: "Root"
});

var CheckboxTreeBase = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxTreeBase, _React$Component);

  var _super = _createSuper(CheckboxTreeBase);

  function CheckboxTreeBase() {
    var _this;

    _classCallCheck(this, CheckboxTreeBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "hasChildren", function (node) {
      return !!node.children && node.children.length > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "getLeafValuesRecursive", function (node) {
      var includeDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!_this.hasChildren(node)) {
        return includeDisabled || !node.disabled ? [node.value] : [];
      }

      return node.children.reduce(function (acc, c) {
        if (_this.hasChildren(c)) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(_this.getLeafValuesRecursive(c, includeDisabled)));
        } else {
          return includeDisabled || !c.disabled ? [].concat(_toConsumableArray(acc), [c.value]) : acc;
        }
      }, []);
    });

    _defineProperty(_assertThisInitialized(_this), "getIndeterminateState", function (node) {
      // an indeterminate node is one where it's children are partially selected
      var value = _this.props.value;
      var currentValues = Array.isArray(value) ? value : [];

      var leafValues = _this.getLeafValuesRecursive(node, true);

      var selectedLeafValues = leafValues.filter(function (v) {
        return currentValues.includes(v);
      });
      if (selectedLeafValues.length === 0) return 0; // none

      if (selectedLeafValues.length < leafValues.length) return 1; // partial

      return 2; // all
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (node, checked) {
      var _this$props = _this.props,
          value = _this$props.value,
          readOnly = _this$props.readOnly;
      if (readOnly) return;
      var currentValues = Array.isArray(value) ? value : [];

      var leafValues = _this.getLeafValuesRecursive(node);

      var missingValues = leafValues.filter(function (v) {
        return !currentValues.includes(v);
      });

      if (missingValues.length > 0) {
        _this.props.onChange([].concat(_toConsumableArray(currentValues), _toConsumableArray(missingValues)));
      } else {
        var newValues = currentValues.filter(function (v) {
          return !leafValues.includes(v);
        });

        _this.props.onChange(newValues);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderNode", function (node) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly;

      var indeterminateState = _this.getIndeterminateState(node);

      return /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          indeterminate: indeterminateState === 1,
          checked: indeterminateState === 2,
          onChange: function onChange(e) {
            return _this.onChange(node, e.target.checked);
          },
          readOnly: readOnly
        }),
        label: node.label,
        disabled: disabled || node.disabled,
        className: node.className
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderNodes", function (nodes) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, nodes.map(function (n) {
        return /*#__PURE__*/React.createElement(TreeItem, {
          key: n.value,
          nodeId: n.value,
          label: _this.renderNode(n)
        }, Array.isArray(n.children) ? _this.renderNodes(n.children) : null);
      }));
    });

    return _this;
  }

  _createClass(CheckboxTreeBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          errors = _this$props3.errors,
          showErrors = _this$props3.showErrors,
          allErrors = _this$props3.allErrors,
          animateErrors = _this$props3.animateErrors,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          renderReadOnly = _this$props3.renderReadOnly,
          label = _this$props3.label,
          labelProps = _this$props3.labelProps,
          width = _this$props3.width,
          fluid = _this$props3.fluid,
          required = _this$props3.required,
          passThruProps = _this$props3.passThruProps,
          nodes = _this$props3.nodes,
          forwardedRef = _this$props3.forwardedRef,
          className = _this$props3.className;
      var muiProps = omitProps(passThruProps, Object.keys(CheckboxTreeBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && renderReadOnly ? function () {
          return renderReadOnly(_this2.props);
        } : false,
        width: width,
        fluid: fluid,
        label: label,
        labelProps: labelProps,
        errors: fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors,
        className: classnames(componentRoot.className, className),
        ref: forwardedRef
      }, /*#__PURE__*/React.createElement(TreeView, _extends({
        disableSelection: true,
        sx: {
          ".MuiCheckbox-root": {
            p: "0.1em",
            mx: "0.5em"
          }
        }
      }, muiProps), this.renderNodes(nodes)));
    }
  }]);

  return CheckboxTreeBase;
}(React.Component);

_defineProperty(CheckboxTreeBase, "propTypes", {
  notifiedFields: propTypes.arrayOf(propTypes.string),
  customValidator: propTypes.func,
  customErrors: propTypes.arrayOf(propTypes.string),
  readOnly: propTypes.bool,
  disabled: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  allErrors: propTypes.bool,
  showErrors: propTypes.bool,
  field: propTypes.string.isRequired,
  requiredError: propTypes.string,
  required: propTypes.bool,
  variant: propTypes.any,
  sx: propTypes.any,
  className: propTypes.string,
  renderReadOnly: propTypes.func,
  nodes: propTypes.arrayOf(propTypes.shape({
    value: propTypes.string.isRequired,
    label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.element]).isRequired,
    children: propTypes.arrayOf(propTypes.shape({
      value: propTypes.string.isRequired,
      label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.element]).isRequired,
      children: propTypes.arrayOf(propTypes.shape({
        value: propTypes.string.isRequired,
        label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.element]).isRequired,
        children: propTypes.arrayOf(propTypes.object),
        className: propTypes.string,
        disabled: propTypes.bool
      })),
      className: propTypes.string,
      disabled: propTypes.bool
    })),
    className: propTypes.string,
    disabled: propTypes.bool
  })).isRequired,
  fluid: propTypes.bool,
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  labelProps: propTypes.any,
  label: propTypes.node
});

_defineProperty(CheckboxTreeBase, "defaultProps", {
  value: [],
  onChange: function onChange() {}
});

var ConnectedCheckboxTree = connectForm$1({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  },
  validators: [requiredField(false)]
})(CheckboxTreeBase);
var CheckboxTreeRoot = styled(ConnectedCheckboxTree, componentRoot.styledOptions)(function (_ref) {
  var theme = _ref.theme;
  return {
    "> .CinForm-label:first-of-type": {
      marginBottom: theme.spacing(0.5)
    }
  };
});
/**
 * Field for a tree-view of checkboxes
 */

var CheckboxTree = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(CheckboxTreeRoot, _extends({}, rootProps, {
    ref: ref
  }));
});
var CheckboxTree$1 = CheckboxTree;

export { CheckboxTree$1 as default };
